const transformDimensions = (dimensions: number[]) => {
  if (!dimensions) {
    return [];
  }

  return dimensions.map((dimension: number) => ({ id: dimension.toString() }));
};

export default transformDimensions;
